"use client";

import { Switch as ShadcnSwitch } from "@/components/ui/switch";
import { cn } from "@/lib/utils/general-utils";
import { forwardRef } from "react";

export interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  name?: string;
  id?: string;
  className?: string;
  /** @deprecated No longer used -- styling is handled by design tokens. */
  color?: string;
}

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  function Switch(
    {
      onChange,
      onCheckedChange,
      color: _color,
      className,
      // Keep controlled for the component lifetime (Base UI warns on undefined → boolean).
      checked = false,
      ...props
    },
    ref,
  ) {
    return (
      <ShadcnSwitch
        ref={ref}
        checked={checked}
        onCheckedChange={onCheckedChange ?? onChange}
        className={cn(className)}
        {...props}
      />
    );
  },
);
